module.exports = __webpack_public_path__ + "img/hr-sand-decal-09.9bd2f2ce.png";